import { call, put } from "redux-saga/effects";
import { setProducts } from "../../slices/product/productSlice";
import { goBack, push } from "connected-react-router";
import {
  requestGetAllProducts,
  requestAddProduct,
  requestEditProduct,
  requestDeleteProduct,
} from "../requests/product";

export function* handleAddProduct(action) {
  try {
    yield call(requestAddProduct(action));
    yield put(goBack());
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetAllProducts(action) {
  try {
    const response = yield call(requestGetAllProducts);
    const { data } = response;
    yield put(setProducts({ data }));
  } catch (error: any) {
    if (error.response.status) {
      yield put(setProducts(null));
    }
  }
}

export function* handleSetProducts(action) {
  try {
    yield put(setProducts({ action }));
  } catch (error) {}
}

export function* handleEditProduct(action) {
  try {
    yield call(requestEditProduct(action));
    put(goBack());
  } catch (error) {
    console.log(error);
  }
}

export function* handleDeleteProduct(action) {
  try {
    yield call(requestDeleteProduct(action));
    yield put(push("/"));
  } catch (error) {}
}
